import { Helmet } from 'react-helmet-async';

/**
 * Per-page SEO meta tags.
 * Props: title, description, keywords (optional comma-separated string)
 */
const SEO = ({ title, description, keywords }) => {
    const siteName = 'Kia Kaha Construction';
    const fullTitle = title ? `${title} | ${siteName}` : siteName;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
        </Helmet>
    );
};

export default SEO;
